import { Component } from '@angular/core';
import { UsersService } from './../../../shared/services/users.service';
import { GetUserResponse } from './../../../shared/models/users.models';

@Component({
  templateUrl: 'profile.component.html',
  styleUrls: [ './profile.component.scss' ]
})

export class ProfileComponent {
  employee: any;
  colCountByScreen: object;
  userResponse: GetUserResponse | null = null;

  constructor(private usersService: UsersService) {
    this.colCountByScreen = {
      xs: 1,
      sm: 2,
      md: 3,
      lg: 4
    };
  }

  ngOnInit() {
    this.usersService.getUserInfo().subscribe((response: GetUserResponse) => {
      this.userResponse = response;
      this.employee = {
        Name: this.userResponse.name,
        LastName: this.userResponse.surname,
      };
    });
  }
}
